import React from 'react';

import BasePanel from 'views/panels/base';
import { Banner, Text } from 'cx-component-library';

class ContentAuthView extends BasePanel {
  render() {
    return (
      <form onSubmit={this.handleLoginSubmit}>
        <div className='login login--desktop'>
          <div className='grid--full'>
            <div className='grid__item'>
              <div className='login__header'>
                <div className='logo-image' />
              </div>
            </div>

            <div className='grid__item' style={{ marginTop: '0' }}>
              <div className='login__content login__content--desktop'>
                <div id='login'>
                  <div className='login__error gutter--top'>
                    <Banner
                      border
                      text={this.getString('general.loginDisabled')}
                      theme='error'
                    />
                  </div>

                  <div className='login__buttons'>
                    <ul className='login__sublinks'>
                      <li className='login__sublink pull-right'>
                        <Text
                          type='a'
                          href='http://www.foresee.com/about-us/privacy-policy/'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {this.getString('general.privacy')}
                        </Text>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ContentAuthView;
